(function () {
  var d = document;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function fmt(cents) {
    try { return new Intl.NumberFormat(d.documentElement.lang || 'en', { style: 'currency', currency: window.swCurrency || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function closePanels() {
    $$('[data-sw-panel]').forEach(function (p) { p.hidden = true; });
    $$('[data-sw-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    d.documentElement.classList.remove('sw-lock');
  }
  function openPanel(name) {
    var p = $('[data-sw-panel="' + name + '"]');
    if (!p) return;
    p.hidden = false;
    $$('[data-sw-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    if (name === 'menu') d.documentElement.classList.add('sw-lock');
    var f = $('input[type="search"]', p); if (f) f.focus();
  }
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-sw-open]');
    if (o) {
      e.preventDefault();
      var name = o.getAttribute('data-sw-open');
      var p = $('[data-sw-panel="' + name + '"]');
      var wasOpen = p && !p.hidden;
      closePanels();
      if (!wasOpen) openPanel(name);
      return;
    }
    if (e.target.closest('[data-sw-close]')) { e.preventDefault(); closePanels(); return; }
    if (e.target.hasAttribute && e.target.hasAttribute('data-sw-backdrop')) closePanels();
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  function setCount(n) { $$('[data-sw-cart-count]').forEach(function (el) { el.textContent = 'Cart (' + n + ')'; }); }
  function getCart() { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }

  $$('[data-sw-product]').forEach(function (el) {
    var jsonEl = $('[data-sw-product-json]', el); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var stock = {};
    try { stock = JSON.parse(($('[data-sw-stock-json]', el) || {}).textContent || '{}'); } catch (e) {}
    var form = $('[data-sw-product-form]', el);
    var idInput = $('[data-sw-variant-id]', el);
    var priceEl = $('[data-sw-price]', el);
    var addBtn = $('[data-sw-add]', el);
    var inCart = $('[data-sw-incart]', el);
    var msg = $('[data-sw-msg]', el);
    var sets = $$('[data-sw-option]', el);
    if (!idInput) return;
    var current = product.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || product.variants[0];
    var cartQty = {};

    // one of ones: once it's in the cart, the button turns into "In your cart · Checkout"
    function paint() {
      var limit = stock[String(current.id)];
      var have = cartQty[String(current.id)] || 0;
      var maxed = have > 0 && limit !== null && limit !== undefined && have >= limit;
      if (inCart) inCart.hidden = !maxed;
      addBtn.hidden = maxed || !current.available;
      addBtn.disabled = !current.available;
      addBtn.textContent = current.available ? 'Add to cart' : 'Sold out';
    }
    function readCart(cart) {
      cartQty = {};
      (cart.items || []).forEach(function (it) { cartQty[String(it.variant_id)] = (cartQty[String(it.variant_id)] || 0) + it.quantity; });
      setCount(cart.item_count);
      paint();
    }
    function sync() {
      sets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (inp) {
          inp.checked = inp.value === current.options[i];
          var ok = product.variants.some(function (v) { return v.available && v.options[i] === inp.value && v.options.every(function (o, j) { return j === i || o === current.options[j]; }); });
          inp.parentNode.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function update() {
      idInput.value = current.id;
      priceEl.innerHTML = fmt(current.price) + (current.compare_at_price > current.price ? ' <s>' + fmt(current.compare_at_price) + '</s>' : '');
      msg.textContent = '';
      paint();
      if (window.history && history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', current.id); history.replaceState(null, '', u.toString()); }
      if (current.featured_media) {
        var s = $('[data-media-id="' + current.featured_media.id + '"]', el);
        var m = $('.sw-product__media', el);
        if (s && m && m.scrollWidth > m.clientWidth) m.scrollTo({ left: s.offsetLeft - m.offsetLeft, behavior: 'smooth' });
      }
      sync();
    }
    sets.forEach(function (fs) {
      fs.addEventListener('change', function () {
        var sel = sets.map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
        var match = product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
        if (match) current = match;
        update();
      });
    });
    sync();
    if (!form || !window.fetch) return;
    // keep the button honest when someone comes back with the browser's back button or edits the cart in another tab
    getCart().then(readCart).catch(function () {});
    window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().then(readCart).catch(function () {}); });
    d.addEventListener('visibilitychange', function () { if (!d.hidden) getCart().then(readCart).catch(function () {}); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.hidden) return;
      addBtn.disabled = true; msg.textContent = '';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          return getCart().then(function (cart) {
            readCart(cart);
            if (!res.ok && !(cartQty[String(current.id)] > 0)) msg.textContent = res.j.description || res.j.message || 'Could not add to cart';
            else if (res.ok && !addBtn.hidden) msg.innerHTML = 'Added. <a href="' + root + 'cart">View cart</a>';
          });
        })
        .catch(function (err) { msg.textContent = err.message; addBtn.disabled = !current.available; });
    });
  });
})();
